export default "__VITE_ASSET__Ciq_X0An__"